module.exports = __webpack_public_path__ + "resources/img/equipment_tab3_img5.9d6671010f4a4d3c72d84ed67b66eb7b.jpg";